.tableWrapper {
    overflow-x: scroll;
    width: 100%;
}